// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.header-next[data-v-89246bf8]{position:relative;width:100%;font-size:16px;word-spacing:normal;text-rendering:auto}.header-next__spacer[data-v-89246bf8]{height:82px}@media (max-width:1023px){.header-next__spacer.--with-ribbon[data-v-89246bf8]{height:150px}}.header-next__fixed[data-v-89246bf8]{position:fixed;top:0;right:0;left:0;z-index:46}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
